export default __webpack_public_path__ + "static/media/ussd.465882fb.svg";